import IntraWorkEditModal from "@/components/IntraWorkEditModal";
import axios from "axios";
/* eslint-disable no-console */
export default {
	name: "IntraWorkTable",
	components: { IntraWorkEditModal/*, IntraWorkAddModal*/ },
	data() {
		return {
			componentKey: 0,
			ticketItem: {},
			ticketItems: [],
			activeTickets: [],
			lockedTickets: [],
			defaultWorkItem: {
				SliceId: null,
				TicketId: 0,
				WorkerId: null,
				Worker: null,
				TimeFrom: null,
				TimeTo: null,
				Minutes: 15,
				FixDate: new Date(),
				TransportTime: 0,
				DayTimeCategoryId: 1,
				DayTimeCategory: "day",
				PriorityCase: false,
				WorkTimeTypeId: 3,
				WorkTimeType: "FixTime",
				FollowUp: false,
				WorkDescription: ""
			},
			//workItems: [],
			supportAgents: [],
			dayTimeCategories: [
				//{ id: 0, name: "undefined" },
				{ value: 1, name: "day" },
				{ value: 2, name: "a-day" },
				{ value: 3, name: "night" }
			],
			isEditModalActive: false,
			selectedWorkItem: {},
			isAddModalActive: false,
			isCreateModalActive: false,
			noTicketExists: false,
			showErrorMessage: false,
			intraTicketId: 0,
			ticketTitle: "",
			osTicketId: "",
			apiKey: "",
			supporter: "",
			customerId: "",
			reporterMail: "",
			isLoadingWorkItems: true,
			isLoadingSupportAgents: true,
		};
	},
	async mounted() {
		if (this.$route.query.osTicketId != null) {
			//this.intraTicketId = this.$route.query.ticketId;
			this.osTicketId = this.$route.query.osTicketId;
		}
		if (this.$route.query.apiKey != null) {
			//this.intraTicketId = this.$route.query.ticketId;
			this.apiKey = this.$route.query.apiKey;
			axios.defaults.headers['apiKey'] = this.apiKey; 
		}
		if (this.$route.query.supporter != null) {
			//this.intraTicketId = this.$route.query.ticketId;
			this.supporter = this.$route.query.supporter;
		}
		//console.log(this.$apiUrl + "/osticket/getSupportAgents/");
		this.loadWorkItems();
		axios.get(this.$apiUrl + "/osticket/getSupportAgents/")
			.then(response => {
				this.supportAgents = response.data;
				this.isLoadingSupportAgents = false;
			});
		this.defaultWorkItem.Worker = this.supporter;
		this.dataReady = true;
	},
	//watch: {
	//	getSlices() {
	//		this.ticketItem.Slices = this.ticketItem.Slices;
	//	}
	//},
	filters: {
		//getDayTimeCategoryName(value) {
		//	//console.log(dayTimeCategories);
		//	//return this.dayTimeCategories.find(dtc => dtc.value === value);
		//	return "bla" + value;
		//}
	},
	computed: {
		isAddButtonLocked: function () {
			if (this.isLoadingSupportAgents == true || this.isLoadingWorkItems == true)
				return true;
			else
				return false;
		}
		//activeTickets: function () {
		//	return this.ticketItems.filter(ti => ti.Locked == false);
		//},
		//lockedTickets: function () {
		//	return this.ticketItems.filter(ti => ti.Locked == true);
		//}
	},
	methods: {
		loadWorkItems() {
			this.isLoadingWorkItems = true;
			//console.log("ticketid: " + this.intraTicketId)
			//search by osticketid
			if (this.osTicketId != null && this.osTicketId != 0) {
				console.log(axios.defaults.headers);			

				//axios.get(this.$apiUrl + "/osticket/getTicketWorkByOsTicketId/", {'headers': {'Content-Type': 'application/x-www-form-urlencoded' },
				axios.get(this.$apiUrl + "/osticket/getTicketWorkByOsTicketId/", {
					params: { 
						osticketId: this.$route.query.osTicketId
					}
				})
					.then(response => {
						if (response.data == null || response.data == "null" || response.data.length < 1) {
							this.noTicketExists = true;

							this.intraTicketId = "";
							this.ticketTitle = this.$route.query.ticketTitle;
							this.osTicketId = this.$route.query.osTicketId;
							this.customerId = this.$route.query.customerId;
							this.reporterMail = this.$route.query.reporterMail;
						}
						else {
							this.ticketItems = response.data;

							this.lockedTickets = this.ticketItems.filter(ti => ti.Locked == true);
							this.activeTickets = this.ticketItems.filter(ti => ti.Locked == false);
							
							if (this.activeTickets.length == 0) {
								this.noTicketExists = true;

								this.intraTicketId = "";
								this.ticketTitle = this.$route.query.ticketTitle;
								this.osTicketId = this.$route.query.osTicketId;
								this.customerId = this.$route.query.customerId;
								this.reporterMail = this.$route.query.reporterMail;
							}
							else {
								this.defaultWorkItem.TicketId = this.activeTickets[0].TicketID;
								this.noTicketExists = false;

								this.intraTicketId = this.activeTickets[0].TicketID;
								this.ticketTitle = this.activeTickets[0].TicketTitle;
								this.osTicketId = this.activeTickets[0].OsTicketId;
								this.customerId = this.activeTickets[0].CustomerId;
							}
							

							//this.showErrorMessage = true;
						}
						this.isLoadingWorkItems = false;
						//setTimeout(() => { this.isLoadingWorkItems = false; }, 2000);
					});
			}
		},
		loadWorkItemsByIntraId() {
			//console.log("ticketid: " + this.intraTicketId)
			//if no ticketid is supplied, search by osticketid
			if (this.intraTicketId == null || this.intraTicketId == 0) {
				axios.get("https://intra-api.swiss-support.net/osticket/getTicketWorkByOsTicketId/", { params: { osticketId: this.$route.query.osTicketId } })
					.then(response => {
						if (response.data == null || response.data == "null") {
							this.noTicketExists = true;

							this.ticketTitle = this.$route.query.ticketTitle;
							this.osTicketId = this.$route.query.osTicketId;
							this.customerId = this.$route.query.customerId;
							this.reporterMail = this.$route.query.reporterMail;
						}
						else {
							this.ticketItem = response.data;
							this.defaultWorkItem.TicketId = this.ticketItem.TicketID;
							this.noTicketExists = false;

							this.intraTicketId = this.ticketItem.TicketID;
							this.ticketTitle = response.data.TicketTitle;
							this.osTicketId = response.data.OsTicketId;
							this.customerId = response.data.CustomerId;

							this.showErrorMessage = true;
						}
					});
			}
			//search by supplied ticketid
			else {
				axios.get("https://intra-api.swiss-support.net/osticket/getTicketWork/", { params: { ticketId: this.intraTicketId } })
					.then(response => {
						if (response.data == null || response.data == "null") {
							this.noTicketExists = true;

							this.ticketTitle = this.$route.query.ticketTitle;
							this.osTicketId = this.$route.query.osTicketId;
							this.customerId = this.$route.query.customerId;
							this.reporterMail = this.$route.query.reporterMail;
						}
						else {
							this.ticketItem = response.data;
							this.defaultWorkItem.TicketId = this.ticketItem.TicketID;
							this.noTicketExists = false;

							this.ticketTitle = response.data.TicketTitle;
							this.osTicketId = response.data.OsTicketId;
							this.customerId = response.data.CustomerId;
						}
					});
			}
		},
		openEditModal(workItem) {
			this.selectedWorkItem = workItem;
			this.isEditModalActive = true;
		},
		openAddModal() {
			//this.selectedWorkItem = defaultWorkItem;
			this.isAddModalActive = true;
		},
		onCreateIntraTicket(item) {
			const axiosConfig = {
				headers: {
					'content-type': 'application/x-www-form-urlencoded'
				}
			}

			//remove unrelevant values
			delete item.IntraSliceId;
			delete item.IntraTicketId;

			item.ticketTitle = this.$route.query.ticketTitle;
			item.osTicketId = this.$route.query.osTicketId;
			item.customerId = this.$route.query.customerId;
			item.reporter = this.$route.query.reporter;

			item.isTest = false;

			axios.post("https://intra-api.swiss-support.net/osticket/createTicket/", this.encodeForm(item), axiosConfig)
				.then(response => {
					if (response.data.status == "Success") {
						this.intraTicketId = response.data.ticketInfo.ticketId;
						//this.intraTicketId = 37528;
						this.noTicketExists = false;
						this.loadWorkItems();
					}
					else {
						this.showErrorAlert("Failed to create Ticket. ERROR: " + response.data.message);
					}
				});

			this.isCreateModalActive = false;
		},
		onAddWorkItem(item) {
			item.isTest = false;

			axios.post("https://intra-api.swiss-support.net/osticket/addWorkSlice/", this.encodeForm(item))
				.then(response => {
					if (response.data.status == "Success") {
						this.loadWorkItems();
					}
					else {
						this.showErrorAlert("Failed to add WorkSlice. ERROR: " + response.data.message);
					}
				});
			this.isAddModalActive = false;
		},
		onEditWorkItem(item) {
			item.isTest = false;

			axios.post("https://intra-api.swiss-support.net/osticket/editWorkSlice/", this.encodeForm(item))
				.then(response => {
					if (response.data.status == "Success") {
						this.loadWorkItems();
					}
					else {
						this.showErrorAlert("Failed to save WorkSlice. ERROR: " + response.data.message);
					}
				});

			// close the modal
			this.isEditModalActive = false;
		},
		//testCallback() {
		//	window.parent.postMessage("test1111", "https://osticket.swiss-support.net");
		//},
		deleteWorkItem(item) {
			//let bConfirmed = false;
			//let bLastItem = false;

			const deleteItem = (bLastItem) => {
				let postData = {
					IntraTicketId: item.TicketId,
					IntraSliceId: item.SliceId,
					isTest: false
				}

				axios.post("https://intra-api.swiss-support.net/osticket/deleteWorkSlice/", this.encodeForm(postData))
					.then(response => {
						if (response.data.status == "Success") {
							this.loadWorkItems();
						}
						else {
							if (bLastItem) {
								this.showErrorAlert("Failed to delete Ticket. ERROR: " + response.data.message);
							}
							else {
								this.showErrorAlert("Failed to delete WorkSlice. ERROR: " + response.data.message);
							}
						}
					});
				this.isAddModalActive = false;
			};

			if (this.activeTickets[0].Slices.length == 1) {
				this.$buefy.dialog.confirm({
					title: `Deleting Ticket`,
					confirmText: "Delete Ticket",
					type: "is-danger",
					hasIcon: true,
					message: "Are you sure you want to delete this TICKET?",
					onConfirm: () => {
						//bConfirmed = true;
						//bLastItem = true;
						deleteItem(true);
					}
				});
			}
			else {
				this.$buefy.dialog.confirm({
					title: `Deleting WorkItem`,
					confirmText: "Delete WorkItem",
					type: "is-warning",
					hasIcon: true,
					message: "Are you sure you want to delete this item?",
					onConfirm: () => {
						//bConfirmed = true;
						deleteItem(false);
					}
				});
			}

			//if (bConfirmed) {
			//	let postData = {
			//		IntraTicketId: item.TicketId,
			//		IntraSliceId: item.SliceId,
			//		isTest: false
			//	}

			//	axios.post("https://intra-api.swiss-support.net/osticket/deleteWorkSlice/", this.encodeForm(postData))
			//		.then(response => {
			//			if (response.data.status == "Success") {
			//				this.loadWorkItems();
			//			}
			//			else {
			//				if (bLastItem) {
			//					this.showErrorAlert("Failed to delete Ticket. ERROR: " + response.data.message);
			//				}
			//				else {
			//					this.showErrorAlert("Failed to delete WorkSlice. ERROR: " + response.data.message);
			//				}
			//			}
			//		});
			//	this.isAddModalActive = false;
			//}
		},
		getDayTimeCategoryName(value) {
			return this.dayTimeCategories.find(dtc => dtc.value === value).name;
		},
		getSupportAgentName(id) {
			return this.supportAgents.find(sa => sa.id === id).name;
		},
		showErrorAlert(message) {
			this.$buefy.dialog.alert({
				title: "Error",
				message: message,
				type: "is-danger",
				hasIcon: true
			});
		},
		getObjSum(wi, property) {
			let s = 0;
			for (var i = 0; i < wi.length; i++) {
				s += wi[i][property];
			}
			return s;
		},
		getDayColorClass(date) {
			if (date.getDay() == 0 || date.getDay() == 6)
				return "redtext";
			else
				return "";
		},
		encodeForm(data) {
			return Object.keys(data)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
				.join('&');
		},
		saveLocalStorageWorkItems() {
			localStorage.setItem("workItems", JSON.stringify(this.workItems));
			this.workItems = JSON.parse(localStorage.getItem("workItems"));
		}
	}
};